(function () {
  // Shared eBook add-on controller — revision 5, 6 Oct 2026.
  //
  // TWO BUGS FIXED THIS ROUND, both introduced by revision 4.
  //
  // 1. THE TICK NEVER SHOWED ON /cart.
  //    Revision 4 renamed the element's id to stop main-cart.liquid's
  //    delegated handler matching it. That worked — but the cart page draws
  //    the tick with an inline rule keyed to the OLD id:
  //      .rw-cart-ebook-addon #rwCartEbookToggle:checked + .rw-check::after
  //    so the mark's opacity stayed 0 even though the input was checked.
  //    The id rename is kept (it is what stopped the two scripts fighting),
  //    and the styling is restored below with id-agnostic rules keyed to the
  //    .rw-ebook-checkbox class instead.
  //
  // 2. UNTICKING SNAPPED BACK AND NEVER REMOVED THE LINE.
  //    Revision 4 added "the cart is the source of truth":
  //      if (lines.length && !getIntent()) setIntent(true);
  //    On untick, intent became 0, normalize ran, the fee line was still in
  //    the cart (nothing had removed it yet), and that line flipped intent
  //    straight back to 1. The box re-ticked within ~3s and no /cart/* write
  //    ever fired. The rule fought the user's own click.
  //    Intent is now THREE-STATE: '1', '0', or absent. The cart is consulted
  //    only when the user has never expressed a preference in this browser,
  //    so an explicit untick is always respected.

  if (window.__rwEbookAddonInit) return;
  window.__rwEbookAddonInit = true;

  var EBOOK_PROPERTY_KEY = '_ebook_access';
  var EBOOK_PROPERTY_VALUE = 'Digital Access';
  var EBOOK_PERCENT = 10;
  var SAFETY_POLL = 45000;
  var DEBOUNCE_MS = 450;
  var INTENT_KEY = 'rw_ebook_wanted';
  var RELOAD_GUARD_KEY = 'rw_ebook_reload_guard';
  var MAX_FAILURES = 3;
  var CART_TOGGLE_ID = 'rwCartEbookToggle';
  var ADOPTED_ID = 'rwCartEbookToggleOwned';

  var EBOOK_VARIANTS = {
    50: 48474789118197, 75: 48474789150965, 100: 47453825925365, 125: 48474789183733,
    150: 48474789216501, 175: 48474789249269, 200: 47453825958133, 225: 48474789282037,
    250: 48474789314805, 275: 48474789347573, 300: 47453825990901, 350: 48474789380341,
    400: 47453826023669, 450: 48474789413109, 500: 47453826056437, 550: 48474789445877,
    600: 47453826089205, 650: 48474789478645, 700: 48474789511413, 750: 48474789544181,
    800: 47453826121973, 900: 48474789576949, 1000: 47453826154741, 1100: 48474789609717,
    1200: 47453826187509, 1300: 48474789642485, 1400: 48474789675253, 1500: 47453826220277,
    1650: 48474789708021, 1800: 48474789740789, 1950: 48474789773557, 2000: 47453826253045,
    2100: 48474789806325, 2250: 48474789839093, 2300: 47453826285813, 2400: 48474789871861,
    2500: 47453826318581, 2550: 48474789904629, 2700: 48474789937397, 2850: 48474789970165,
    3000: 47453826351349, 3250: 48474790002933, 3500: 48089530040565, 4000: 48089530073333,
    4500: 48089530106101, 5000: 48089530138869, 5250: 48474790035701, 5500: 48474790068469,
    5750: 48474790101237, 6000: 48474790134005, 6500: 48479907676405, 7000: 48479907709173,
    7500: 48479907741941, 8000: 48479907774709, 8500: 48479907807477, 9000: 48479907840245,
    9500: 48479907873013, 10000: 48479907905781, 11000: 48479907938549, 12000: 48479907971317,
    13000: 48479908004085, 14000: 48479908036853, 15000: 48479908069621, 16000: 48479908102389,
    17000: 48479908135157, 18000: 48479908167925, 19000: 48479908200693, 20000: 48479908233461
  };

  var EBOOK_IDS = {};
  Object.keys(EBOOK_VARIANTS).forEach(function (t) { EBOOK_IDS[EBOOK_VARIANTS[t]] = true; });

  var isProcessing = false;
  var debounceTimer = null;
  var failures = 0;
  var disabled = false;
  var pollTimer = null;
  var suppressObserver = false;

  // ------------------------------------------------------- styling restore
  // Keyed to the class, not an id, so a future rename cannot break it again.
  function injectStyles() {
    if (document.getElementById('rw-ebook-styles')) return;
    var css =
      '.rw-cart-ebook-addon input.rw-ebook-checkbox{position:absolute;opacity:0;width:0;height:0;pointer-events:none}' +
      '.rw-cart-ebook-addon input.rw-ebook-checkbox:checked + .rw-check::after{opacity:1}' +
      '.rw-cart-ebook-addon input.rw-ebook-checkbox:checked + .rw-check{border-color:currentColor}';
    var style = document.createElement('style');
    style.id = 'rw-ebook-styles';
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  // --------------------------------------------------- intent (3-state)
  // '1' = wanted, '0' = explicitly declined, null = never chosen here.
  function storedIntent() {
    try { return localStorage.getItem(INTENT_KEY); } catch (e) { return null; }
  }
  function getIntent() { return storedIntent() === '1'; }
  function setIntent(v) {
    try { localStorage.setItem(INTENT_KEY, v ? '1' : '0'); } catch (e) {}
  }

  function giveUp(why) {
    disabled = true;
    if (pollTimer) clearInterval(pollTimer);
    console.warn('[rw-ebook] disabled: ' + why);
  }
  function noteFailure(why) {
    failures++;
    console.warn('[rw-ebook] failed (' + failures + '/' + MAX_FAILURES + '): ' + why);
    if (failures >= MAX_FAILURES) giveUp('too many consecutive failures; not retrying.');
  }

  async function getCart() {
    suppressObserver = true;
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('cart.js HTTP ' + res.status);
      return await res.json();
    } finally { suppressObserver = false; }
  }

  async function changeLine(key, quantity) {
    suppressObserver = true;
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!res.ok) throw new Error('change.js HTTP ' + res.status);
      return await res.json();
    } finally { suppressObserver = false; }
  }

  async function addEbook(variantId) {
    suppressObserver = true;
    try {
      var props = {};
      props[EBOOK_PROPERTY_KEY] = EBOOK_PROPERTY_VALUE;
      props._ebook_calc = EBOOK_PERCENT + '% of cart value';
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      });
      if (!res.ok) {
        var detail = '';
        try { var d = await res.json(); detail = d.description || d.message || ''; } catch (e) {}
        throw new Error('add.js HTTP ' + res.status + (detail ? ' \u2014 ' + detail : ''));
      }
      return await res.json();
    } finally { suppressObserver = false; }
  }

  function isEbookLine(i) {
    if (EBOOK_IDS[i.variant_id] || EBOOK_IDS[i.id]) return true;
    return !!(i.properties && i.properties[EBOOK_PROPERTY_KEY] === EBOOK_PROPERTY_VALUE);
  }
  function ebookLines(cart) { return (cart.items || []).filter(isEbookLine); }

  function nearestTier(amount) {
    return Object.keys(EBOOK_VARIANTS).map(Number).reduce(function (a, b) {
      return Math.abs(b - amount) < Math.abs(a - amount) ? b : a;
    });
  }

  function getCheckboxes() {
    var list = Array.prototype.slice.call(document.querySelectorAll('.rw-ebook-checkbox'));
    [CART_TOGGLE_ID, ADOPTED_ID].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && list.indexOf(el) === -1) list.push(el);
    });
    return list;
  }
  function setAllCheckboxes(checked) {
    getCheckboxes().forEach(function (cb) { cb.checked = checked; });
  }

  function adoptCartToggle() {
    var el = document.getElementById(CART_TOGGLE_ID);
    if (!el) return;
    var clone = el.cloneNode(true);
    clone.id = ADOPTED_ID;
    clone.dataset.rwAdopted = '1';
    clone.classList.add('rw-ebook-checkbox');
    clone.checked = getIntent();
    if (el.parentNode) el.parentNode.replaceChild(clone, el);
  }

  function wireCheckboxes() {
    adoptCartToggle();
    getCheckboxes().forEach(function (cb) {
      if (cb.dataset.rwWired) return;
      cb.dataset.rwWired = '1';
      cb.checked = getIntent();
      cb.addEventListener('change', function () {
        setIntent(cb.checked);
        setAllCheckboxes(cb.checked);
        scheduleNormalize();
      });
    });
  }

  function reloadForFreshCart() {
    try {
      if (sessionStorage.getItem(RELOAD_GUARD_KEY) === '1') {
        sessionStorage.removeItem(RELOAD_GUARD_KEY);
        return;
      }
      sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
    } catch (e) {}
    window.location.reload();
  }
  function clearReloadGuard() {
    try { sessionStorage.removeItem(RELOAD_GUARD_KEY); } catch (e) {}
  }

  async function normalize() {
    if (disabled || isProcessing) return;
    isProcessing = true;
    try {
      var cart = await getCart();
      var lines = ebookLines(cart);

      // Adopt the cart's state ONLY when the shopper has never chosen in this
      // browser. An explicit '0' is never overridden — that was the bug.
      if (storedIntent() === null && lines.length) setIntent(true);

      var wantEbook = getIntent();
      setAllCheckboxes(wantEbook);

      if (!wantEbook) {
        if (lines.length) {
          for (var i = 0; i < lines.length; i++) await changeLine(lines[i].key, 0);
          failures = 0;
          reloadForFreshCart();
          return;
        }
        failures = 0;
        clearReloadGuard();
        return;
      }

      if (!cart || cart.item_count === 0) { failures = 0; clearReloadGuard(); return; }

      var subtotal = (cart.items || []).reduce(function (sum, item) {
        return isEbookLine(item) ? sum : sum + item.line_price;
      }, 0) / 100;

      if (subtotal <= 0) { failures = 0; return; }

      var wantVariant = EBOOK_VARIANTS[nearestTier(Math.round(subtotal * EBOOK_PERCENT / 100))];
      var changed = false;
      var keep = null;

      for (var j = 0; j < lines.length; j++) {
        var line = lines[j];
        var isRight = (line.variant_id === wantVariant || line.id === wantVariant) && line.quantity === 1;
        if (!keep && isRight) { keep = line; continue; }
        await changeLine(line.key, 0);
        changed = true;
      }
      if (!keep) { await addEbook(wantVariant); changed = true; }

      failures = 0;
      if (changed) { reloadForFreshCart(); return; }
      clearReloadGuard();
      setAllCheckboxes(true);
    } catch (e) {
      noteFailure(e && e.message ? e.message : String(e));
    } finally {
      isProcessing = false;
    }
  }

  function scheduleNormalize() {
    if (disabled) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(normalize, DEBOUNCE_MS);
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var watch = !suppressObserver && CART_WRITE.test(url);
      var p = nativeFetch.apply(this, arguments);
      if (watch) p.then(function (r) { if (r && r.ok) scheduleNormalize(); }, function () {});
      return p;
    };
  }
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rwEbookCartWrite = CART_WRITE.test(url || '');
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__rwEbookCartWrite && !suppressObserver) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) scheduleNormalize();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  function boot() {
    injectStyles();
    wireCheckboxes();
    setAllCheckboxes(getIntent());
    normalize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', function () {
    if (disabled) return;
    wireCheckboxes();
    scheduleNormalize();
  });

  var observer = new MutationObserver(function () { wireCheckboxes(); });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  pollTimer = setInterval(function () { if (!disabled) { wireCheckboxes(); normalize(); } }, SAFETY_POLL);
})();
